window.popDependantDdl = (strH1Index, ddlH2Container) => {
    var strH2ArrayItems;
    var strH2ArrayValues;
    ddlH2Container.options.length = 0;
    if (strH1Index != '0') {
        strH2ArrayItems = eval('arrH2Items_' + strH1Index);
        strH2ArrayValues = eval('arrH2Values_' + strH1Index);
        var count = 0;
        for (var i = 0; i < strH2ArrayItems.length; i++) {
            ddlH2Container.options[ddlH2Container.options.length] = new Option(strH2ArrayItems[i], strH2ArrayValues[i]);
            count++;
        }
    }
    else {
        ddlH2Container.options[ddlH2Container.options.length] = new Option('', '0');
    }

    if (count > 0) {
        document.querySelectorAll('[id$=ddlAdSourceH2]')[0].parentElement.style.display = "block";
    } else {
        document.querySelectorAll('[id$=ddlAdSourceH2]')[0].parentElement.style.display = "none";
    }
    if (strH1Index == 899) {
        //hide second option box if 'dont know' selected.
        document.querySelectorAll('[id$=ddlAdSourceH2]')[0].parentElement.style.display = "none";
    }
}